import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { QUERY_KEY_USERS } from "Data/keys/QueryKeys";
import { TenantApiV2 } from "Data/Tenant.api.v2";

export const useQueryUsers = () => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [QUERY_KEY_USERS],
    staleTime: 60 * 5 * 1000, // 5 minutes
    queryFn: async () => {
      const { data } = await TenantApiV2.listUsers();
      return data.data;
    },
  });

  const dataDefault = useMemo(() => [], []);

  return {
    data: data ?? dataDefault,
    refetch,
    isLoading,
    isFetching,
    error,
  }
};
